import ChildIndicator from '../molecules/ChildIndicator';
import silhoutte from '../atoms/PersonSilhouette/PersonSilhouette.png';

const ChildIndicatorContainer = ({ studentArray = [], ...props }) => {
  //studentArray: array with at least a 'name' key in it
  return (
    <div className='grid grid-cols-3 content-center items-center justify-center gap-x-3 md:grid-cols-4 md:justify-start lg:grid-cols-6 '>
      {studentArray.length > 0 ? (
        studentArray?.map((student, index) => {
          return (
            <div key={index} className=' text-center'>
              <ChildIndicator student={student} {...props}>
                {student.name}
              </ChildIndicator>
            </div>
          );
        })
      ) : (
        <div className=' text-center'>
          <ChildIndicator>New Student</ChildIndicator>
        </div>
      )}
    </div>
  );
};

export default ChildIndicatorContainer;
